import React, { SVGProps } from 'react';

const MetamaskIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 20 21"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4681 6.68548C14.6052 5.4509 13.3348 4.52214 11.852 4.09425L12.3405 2.53374C14.1096 3.09789 15.6688 4.27059 16.7505 5.78075L15.4681 6.68548ZM15.5403 14.2097C16.2517 13.1492 16.6667 11.8732 16.6667 10.5003L18.3151 10.5003C18.3151 12.1809 17.7513 13.8014 16.8096 15.1646L15.5403 14.2097ZM14.4944 14.2239C14.538 14.1501 14.5924 14.0892 14.6537 14.0423C15.3823 13.0765 15.803 11.856 15.803 10.5003C15.803 7.21617 13.3493 4.64797 10.0001 4.64797C6.65084 4.64797 4.22176 7.17311 4.22176 10.5003C4.22176 13.8275 6.66597 16.2747 10.0001 16.2747C11.8434 16.2747 13.4223 15.5135 14.4657 14.2778C14.4744 14.2595 14.484 14.2415 14.4944 14.2239ZM10.0001 17.167C10.741 17.167 11.4536 17.0461 12.1194 16.8231L12.6127 18.4522C11.7827 18.7556 10.9023 18.9225 10.0001 18.9225C9.1018 18.9225 8.2198 18.757 7.3846 18.4562L7.88539 16.8246C8.54985 17.0467 9.26092 17.167 10.0001 17.167ZM3.33341 10.5003C3.33341 11.9089 3.77027 13.2155 4.5159 14.2919L3.16795 15.2532C2.16541 13.872 1.55759 12.2174 1.55759 10.5003L3.33341 10.5003ZM7.94495 4.15644C6.51777 4.61845 5.30129 5.54868 4.47667 6.76599L3.10375 5.86517C4.17407 4.36959 5.71544 3.19476 7.45484 2.59757L7.94495 4.15644ZM1.95664 5.76305C3.58023 3.01229 6.57466 1.16699 10.0001 1.16699C15.1547 1.16699 19.3334 5.34567 19.3334 10.5003C19.3334 15.655 15.1547 19.8337 10.0001 19.8337C4.84542 19.8337 0.666748 15.655 0.666748 10.5003C0.666748 8.85144 1.09433 7.30242 1.84467 5.95809C1.8616 5.90936 1.88515 5.86195 1.91555 5.81707C1.92838 5.79812 1.94211 5.78011 1.95664 5.76305Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.45 8.6337C13.1833 9.33134 13.1833 10.469 12.45 11.1667L10.0001 13.4964L7.55033 11.1668C6.81652 10.4691 6.81662 9.3316 7.55024 8.6337C8.21025 8.00629 9.27275 8.00618 9.93277 8.63357L9.99998 8.69745L10.067 8.63369C10.727 8.00627 11.7899 8.00627 12.45 8.6337Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default MetamaskIcon;
